import moment from "moment";
import React from "react";
import styled from "styled-components";

import { GUTTER_WIDTH, HOURS_PER_DAY, LAYER, PX_PER_HOUR } from "../constants";

interface ShiftTimeLineColumnProps {
  daysToShow: string[];
  totalHours: number;
}

const hourLabel = (hourOfDay: number) =>
  `${hourOfDay % 12 || 12}${hourOfDay >= 12 ? "pm" : "am"}`;

/** The pinned time axis down the left edge. */
export const ShiftTimeLineColumn: React.FC<ShiftTimeLineColumnProps> = ({
  daysToShow,
  totalHours,
}) => (
  <CalendarColumnSmall>
    {Array.from({ length: totalHours }, (_, hour) => {
      const hourOfDay = hour % HOURS_PER_DAY;
      const day = daysToShow[Math.floor(hour / HOURS_PER_DAY)];
      return (
        <TimeBlock key={hour} isDayStart={hourOfDay === 0}>
          {hourOfDay === 0 && <b>{moment(day).format("ddd")}</b>}
          {hourLabel(hourOfDay)}
        </TimeBlock>
      );
    })}
  </CalendarColumnSmall>
);

const CalendarColumnSmall = styled.div`
  flex: 0 0 ${GUTTER_WIDTH}px;
  position: sticky;
  left: 0;
  z-index: ${LAYER.gutter};
  background: ${({ theme }) => theme.globalConstants.color.white};
  border-right: 1px solid
    ${({ theme }) => theme.globalConstants.color.borderGray};
`;

const TimeBlock = styled.div<{ isDayStart: boolean }>`
  box-sizing: border-box;
  height: ${PX_PER_HOUR}px;
  border-top: 1px solid
    ${({ theme, isDayStart }) =>
      isDayStart
        ? theme.globalConstants.color.textSecondary
        : theme.globalConstants.color.backgroundGrayDark};
  font-size: 14px;
  color: ${({ theme }) => theme.globalConstants.color.textSecondary};
  text-align: right;
  padding: 4px 12px 0 0;
  font-variant-numeric: tabular-nums;

  b {
    display: block;
    color: ${({ theme }) => theme.globalConstants.color.textBody};
    font-size: 14px;
  }
`;
